import React, { Component } from "react";
import "./Home.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import logo from '../../assets/images/streetlink_logo.png';
import upIcon from '../../assets/images/up.png';

export default class Home extends Component {
    constructor() {
        super();
        this.state = {
            show: true,
            showDisclaimer: true,
            isVisible: false
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.jumpHome = this.jumpHome.bind(this);
    }

    showModal = () => {
        this.setState({ show: true });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    hideDisclaimer = () => {
        this.setState({ showDisclaimer: false });
    };

    componentDidMount() {
        this.deleteAllCookies();
        window.addEventListener('scroll', this.toggleVisibility);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleVisibility);
    }

    deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        localStorage.clear();
        sessionStorage.clear();
    }

    toggleVisibility = () => {
        if (window.pageYOffset > 0) {
            this.setState({ isVisible: true });
        } else {
            this.setState({ isVisible: false });
        }
    };

    jumpHome() {
        document.getElementById("navbarId").scrollIntoView({ behavior: "smooth" });
    }

    render() {
        return (
            <div>
                <div className="introSection" id="introId">
                    <div className="masthead-home">
                        <div className="logo">
                            <img className="logoImage" src={logo} alt="logo" />
                        </div>
                    </div>
                    {this.state.isVisible && (
                        <button className="floatingButton" onClick={this.jumpHome}>
                            <img className="up" src={upIcon} alt="up arrow icon" />
                        </button>
                    )}
                    <Container>
                        <Row className="justify-content-center rowCol">
                            <Col lg={12}>
                                <p className="mainTitle">Streetlink Homeless Support</p>
                                <p className="mainBlurb bgBlurb blurbMargins">
                                    Streetlink Homeless Support (SHS) was founded in March 2020 during the COVID-19
                                    pandemic. With the beginning of the lockdown, access to services provided by the state and
                                    NGOs for rough sleepers and those living in active addiction was severely restricted. Seeing
                                    the need to support those affected, SHS took action.

                                    <br /><br />
                                    During this time SHS provided an assertive outreach program offering advocacy services to
                                    those in need with state-provided homeless, health and social services. Where required SHS
                                    provided those in need with essentials like tents, sleeping bags and changes of clean clothing.

                                    <br /><br />
                                    As time went by and COVID-19 restrictions were lifted, SHS continued to see great demand
                                    for its assertive outreach programs. Today SHS is one of the largest homeless outreach
                                    facilitators providing advocacy for rough sleepers and the drug-using community.

                                    </p>
                                <Col lg={12}><p className="mainTitle">Our Vision</p></Col>
                                <p className="mainBlurb bgBlurb-vision blurbMargins-home">
                                    That people trapped in homelessness and who use drugs are
                                    treated with equality, and respect
                                    and have a voice where decisions affecting their lives are made.</p>

                                <Col lg={12}><p className="mainTitle">Our Mission</p></Col>
                                <p className="mainBlurb bgBlurb-mission blurbMargins-home">
                                    To provide advocacy for the homeless and people who use drugs. To work towards protecting
                                    their civil liberties and human rights within state services.
                                </p>

                                <p className="mainTitle">Our Values</p>
                                <p className="mainBlurb bgBlurb blurbMargins">
                                    Homeless individuals and people struggling with substance abuse have rights, but not
                                    everyone knows how to advocate for themselves and may be unaware that change is possible. <br /><br />
                                    People’s rights are not always respected, protected, and fulfilled. The homeless and substance
                                    users also experience difficulties in claiming and asserting their rights equally. <br /><br />
                                    Despite ongoing support for this community, their rights are not fully established in Ireland.
                                    Decision-makers and service providers often make decisions that impact this community
                                    without taking their rights or dignity into consideration. As a result, many members of the
                                    community face high levels of inequality, discrimination, and stigmatisation.

                                </p>



                            </Col>
                        </Row>
                    </Container>
                </div>

                <br />
                <h4>Copyright 2025 Streetlink Homeless Support | RCN: 20206746 | CHY: 23218</h4>
                <br />
            </div>
        );
    }
}
